import Vue from 'vue'
import vSelect from 'vue-select'

Vue.component('vue-select', vSelect);
